export default __webpack_public_path__ + "static/media/slider_image_01-sm@2x.39473b79.jpg";